import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-[#064E3B] text-white" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
        <div className="flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-white text-sm">
            &copy;  {new Date().getFullYear()} Trademark Pact. All rights reserved.
          </p>
          <div className="flex items-center gap-4 text-sm">
            <Link
              to="/privacy-policy"
              className="text-white hover:text-white transition-colors"
              data-testid="footer-privacy-link"
            >
              Privacy Policy
            </Link>
            <span className="text-white">|</span>
            <Link
              to="/terms-of-service"
              className="text-white hover:text-white transition-colors"
              data-testid="footer-terms-link"
            >
              Terms of Service
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
